import clsx from 'clsx';

import Icon from '@components/icon/Icon';
import { DEFAULT_PLACEHOLDER } from '@constants/generic';

import {
  AVATAR_BORDER_TINT,
  FULL_BLEED_SOURCE_ICONS,
  SOURCE_AVATAR_SIZE_CLASSES
} from '../../constants/leadSources';
import {
  getSourceAvatarColor,
  getSourceIconName,
  getSourceInitials
} from '../../utils/sourceAvatar';

interface SourceAvatarProps {
  name: string;
  compact?: boolean;
  className?: string;
}

const SourceAvatar = ({
  name,
  compact = false,
  className
}: SourceAvatarProps) => {
  const sizeClasses =
    SOURCE_AVATAR_SIZE_CLASSES[compact ? 'compact' : 'default'];
  const iconName = getSourceIconName(name);

  if (iconName) {
    const logoSize = FULL_BLEED_SOURCE_ICONS.has(iconName)
      ? sizeClasses.fullBleedLogo
      : sizeClasses.tile;

    return (
      <Icon
        name={iconName}
        size="none"
        className={clsx('shrink-0', logoSize, className)}
      />
    );
  }

  const color = getSourceAvatarColor(name);

  return (
    <div
      className={clsx(
        'flex shrink-0 items-center justify-center rounded-[4.4px] border',
        'font-semibold',
        AVATAR_BORDER_TINT,
        sizeClasses.initials,
        color.bg,
        color.text,
        className
      )}
      aria-hidden
    >
      {getSourceInitials(name) || DEFAULT_PLACEHOLDER}
    </div>
  );
};

export default SourceAvatar;
